// Libs
// import jQuery from 'jquery'
// import Swal from 'sweetalert2';
// import flatpickr from 'flatpickr';
// import jQuery from 'jquery';

import ModuleSwiper from './Public/ModuleSwiper';
import ModuleCalcElement from './Public/ModuleCalcElement';
import ModuleFancybox from './Public/ModuleFancybox';
import ModuleCopyToClipboard from './Public/ModuleCopyToClipboard';
import ModuleAria from './Public/ModuleAria';
import ModuleActived from './Public/ModuleActived';
import BackToTop from './Public/BackToTop';
import CountNumbers from './Public/CountNumbers';
import LpAPI from './Public/LpAPI';
import SectionPopup from './Public/popup';
import Toggle from './Public/Toggle';
import ModuleTab from './Public/ModuleTab';

import Header from './Layouts/Header';

const BraneyModulesManager = {
    runModule: function () {
        new ModuleActived();

        new ModuleSwiper();
        new ModuleFancybox();
        new ModuleCalcElement();
        new SectionPopup();
        new Header();

        //
        new ModuleCopyToClipboard().init();
        new ModuleAria().init();
        new BackToTop().init();
        new CountNumbers().init();

        new LpAPI().init();
        new Toggle().init();

        const tab = new ModuleTab(document.querySelector('.js-tabhead'), 'tab');

        const uploadCV = document.querySelector('.upload-cv');
        if (uploadCV){
            const containerUploadCV = uploadCV.querySelector('.ginput_container_fileupload');
            const label = document.createElement('label');
            label.classList.add('label-upload-cv');

            const iconLabel = document.createElement('span');
            iconLabel.style.backgroundImage = `url('data:image/svg+xml,<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15.241" cy="15.766" r="15.241" fill="%23E6EEFF"/><path d="M12.3154 13.8508H11.7229C10.4306 13.8508 9.38281 14.8986 9.38281 16.1909V19.2867C9.38281 20.5784 10.4306 21.6262 11.7229 21.6262H18.7909C20.0832 21.6262 21.1311 20.5784 21.1311 19.2867V16.1846C21.1311 14.8961 20.0864 13.8508 18.7979 13.8508H18.1991" stroke="%2300188F" stroke-width="1.14307" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.255 9.53665V17.1832" stroke="url(%23paint0_linear_469_3491)" stroke-width="1.14307" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.4062 11.3962L15.2574 9.53684L17.1092 11.3962" stroke="url(%23paint1_linear_469_3491)" stroke-width="1.14307" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_469_3491" x1="15.255" y1="17.1832" x2="15.255" y2="9.53665" gradientUnits="userSpaceOnUse"><stop stop-color="%23FE5D02"/><stop offset="1" stop-color="%23FF8C00"/></linearGradient><linearGradient id="paint1_linear_469_3491" x1="15.2577" y1="11.3962" x2="15.2577" y2="9.53684" gradientUnits="userSpaceOnUse"><stop stop-color="%23FE5D02"/><stop offset="1" stop-color="%23FF8C00"/></linearGradient></defs></svg>')`;
            iconLabel.classList.add('icon-upload');

            const txtLabel = document.createElement('span');
            txtLabel.innerText = 'Upload a file or drag and drop here';
            label.appendChild(iconLabel);
            label.appendChild(txtLabel);

            containerUploadCV.insertBefore(label, containerUploadCV.firstChild);

            const inputUploadCV = uploadCV.querySelector('input[type="file"]');
            inputUploadCV.addEventListener('change', ({target}) => {
                let file = target.files[0];
    
                const fragmentUploaded = uploadCV.querySelector('.file-value');
                
                if (fragmentUploaded){
                    fragmentUploaded.remove();
                }
    
    
                if (file){
                    let fileName = file.name;
                    let fileSize = file.size;
    
                    const fragment = document.createDocumentFragment();
                    const fileValueElement = document.createElement('div');
                    fileValueElement.classList.add('file-value');
        
                    const icon = document.createElement('div');
                    icon.classList.add('icon');
                    icon.style.backgroundImage = `
                        url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="28" height="28" viewBox="0 0 30 30"><path fill="%231C3687" d="M24.707,8.793l-6.5-6.5C18.019,2.105,17.765,2,17.5,2H7C5.895,2,5,2.895,5,4v22c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2 V9.5C25,9.235,24.895,8.981,24.707,8.793z M18,10c-0.552,0-1-0.448-1-1V3.904L23.096,10H18z"></path></svg>')
                    `;
                    icon.style.backgroundSize = "contain";
                                    
                    fileValueElement.appendChild(icon);
                    const detailsDiv = document.createElement('div');
                    detailsDiv.classList.add('details');
    
                    const detailsText = document.createElement('span');
                    detailsText.classList.add('name');
                    detailsText.innerHTML = `${fileName} &bull; Uploaded (${(fileSize / 1024).toFixed(2)}KB)`;
                    detailsDiv.appendChild(detailsText);
                    fileValueElement.appendChild(detailsDiv);
    
                    fragment.appendChild(fileValueElement);
    
                    uploadCV.appendChild(fragment);
                }
            })
        }
    }
};

document.addEventListener('DOMContentLoaded', function () {
    BraneyModulesManager.runModule();
})